export interface ViewMoreLink {
  '@path': string;
  '@name': string;
  label: string;
  routerPath: string;
}
